<ap-section-header>
  <ap-section-header-grid
    [iconId]="'ap-dashboard-icon'"
    [caption]="'Global__Dashboard'"
    [filterPlaceholder]="'Global_Filter'"
    [filterTooltip]="'Global__Dashboard'"
    [canCreate]="false"
    [showCanCreateButton]="false"
    [canSearch]="false"
  ></ap-section-header-grid>
</ap-section-header>
<div>
  <ap-news-overview></ap-news-overview>
</div>
